<template lang="html">

    <section class="bonos-ajusa">

        <div class="contenedor-logo container">
            <router-link to="/">
                <img src="/static/img/logo.svg" alt="Logo Ajusa" width="121" height="49"></router-link>
        </div>

        <main class="main-bonos container">

            <div class="contenedor-imagen">
                <img src="/static/img/bonos-ajusa.webp" alt="Bonos Ajusa" width="327" height="401">
            </div>

            <div class="contenedor-textos">

                <h1>Bonos Ajusa
                    <span>Apoyamos al taller mecánico</span>
                    <img src="/static/img/bonos-ajusa.webp" alt="Bonos Ajusa" width="327" height="401">
                </h1>

                <p>Para beneficiarte de la promoción <strong>Bonos Ajusa 20% de descuento</strong>, puedes llamar al 967 216 212 o <span>rellenar este formulario</span>. En breve, nos pondremos en
                    contacto contigo para explicarte cómo canjear los descuentos.</p>

                <form class="formulario-bonos" @submit.prevent="validate" id="form">
                    <div class="contenedor-input">
                        <label for="">CIF del taller mecánico*</label>
                        <input type="text" v-model="form.cif_taller" placeholder="CIF del taller mecánico*" v-validate="'required'" name="cif_taller">
                        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('cif_taller') }}</span>
                    </div>

                    <div class="contenedor-input">
                        <label for="">Nombre del taller mecánico o establecimiento*</label>
                        <input type="text" v-model="form.nombre_taller" placeholder="Nombre del taller*" v-validate="'required'" name="nombre_taller">
                        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('nombre_taller') }}</span>
                    </div>


                    <div class="contenedor-input">
                        <label for="">Teléfono*</label>
                        <input type="text" v-model="form.telefono" placeholder="Teléfono*" v-validate="'required|numeric'" name="telefono">
                        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('telefono') }}</span>
                    </div>

                     <div class="contenedor-input">
                        <label for="">Correo electrónico* </label>
                        <input type="text" v-model="form.email" placeholder="Correo electrónico* " v-validate="'required|email'" name="email">
                        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('email') }}</span>
                    </div>

                    <div class="contenedor-check contenedor-input">
                        <input id="politica" type="checkbox" v-model="form.politica" name="politica" v-validate="'required'" />
                        <label for="politica">He leído y acepto <router-link target="_blank" :to="$t('enlaces.politica')">la política de privacidad</router-link>.</label>
                        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('politica') }}</span>
                    </div>

                    <input type="hidden" name="url" :value="$route.params.id">

                    <button class="btn" :sending="sending">
                        Enviar
                        <half-circle-spinner
                            v-if="sending"
                            :animation-duration="1000"
                            :size="19"
                            color="#ffffff"
                            />
                        </button>

                        <p>Promoción válida para talleres mecánicos, tiendas de recambio, rectificadores y distribuidores de España (incluye Baleares, Canarias, Ceuta y Melilla).</p>

                    </form>

                </div>

            </main>

            <div class="contenedor-popup" v-if="sendend">
                <div class="pop">
                    <router-link to="/" class="cerrar">✕</router-link>
                    <h2>Recibido</h2>
                    <p>En breve, nos pondremos en contacto contigo para explicarte cómo canjear los descuentos.</p>
                </div>
            </div>


        </section>

    </template>

    <script lang="js">

import {mapGetters} from 'vuex';


import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'

  Vue.use(VueAxios, axios);

  import { HalfCircleSpinner } from 'epic-spinners'

  import router from '@/router';


    export default  {
      name: 'bonos-ajusa',
      mounted(){
        this.form.url = this.$route.params.id;
      },
      data(){
          return{
              clicked : false,
              sendend : false,
              sending : false,
              form : {
                  politica : false,
                  cif_taller:'',
                  nombre_taller : '',
                  telefono : '',
                  email : '',
                  url : ''
              }
          }
      },
      methods : {
          validate(){
            this.clicked = true;
            router.replace({ path: '/bonosajusa/click'})

            this.$validator.validateAll().then(canSend => {
            (canSend) ? this.send() : '';
            });
          },
          send(){
              this.sending = true;

              let data = new FormData(document.getElementById("form"));

              this.$ga.event({
                eventCategory: 'bonosajusa',
                eventAction: 'envio',
                eventLabel: this.form.url,
                eventValue: 0
            })

              $.ajax({
                    url: `${this.getServer}bonoajusa/email`,
                    type: 'POST',
                    data: data,
                    cache: false,
                    contentType: false,
                    processData: false,
            }).done(r => {
                this.sendend = true;
                this.sending = false;
                this.clicked = false;
                router.replace({ path: '/bonosajusa/enviado'})
                this.form = {
                  politica : false,
                  cif_taller:'',
                  nombre_taller : '',
                  telefono : '',
                  email : '',
                  url : ''
              }
 })

       

      
          }
      },
      computed:{
        ...mapGetters(['getServer']),
      },
      components : {
        HalfCircleSpinner
    },
    }
  </script>
    <style scoped>

  </style>


// WEBPACK FOOTER //
// src/components/views/bonos-ajusa.vue